import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  WixChooseStationStepFormFieldsEnum,
  yupLanding,
} from "@ryde/utils-landings";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useYupChooseStationLandingValidationSchema = () => {
  const { t } = useTranslation();
  const yupChooseStationLandingValidationSchema = useMemo(() => {
    const employeeNumberPath = t(
      `landing.formLabel.${WixChooseStationStepFormFieldsEnum.EmployeeNumber}`,
    );
    return {
      [WixChooseStationStepFormFieldsEnum.EmployeeNumber]: yupLanding
        .string()
        .required(
          t("landing.validation.required", { path: employeeNumberPath }),
        )
        .matches(
          /^[0-9]+$/,
          t("landing.validation.numberOnly", { path: employeeNumberPath }),
        ),
      [WixChooseStationStepFormFieldsEnum.FirstName]: yupLanding
        .string()
        .required(),
      [WixChooseStationStepFormFieldsEnum.LastName]: yupLanding
        .string()
        .required(),
      [WixChooseStationStepFormFieldsEnum.Email]: yupLanding
        .string()
        .required()
        .email(t("landing.errors.emailInvalid"))
        .test(
          "is-wix-or-goryde-email",
          t("landing.errors.emailMustBeWixOrGoryde"),
          value => {
            if (!value) {
              return false;
            }
            return (
              value.endsWith("@wix.com") ||
              value.endsWith("@base44.com") ||
              value === "eyalg@goryde.com"
            );
          },
        ),
      [WixChooseStationStepFormFieldsEnum.PhoneMobile]: yupLanding
        .string()
        .required(),
      [WixChooseStationStepFormFieldsEnum.SourceStation2Id]: yupLanding
        .number()
        .required(),
      [WixChooseStationStepFormFieldsEnum.DestinationId]: yupLanding
        .number()
        .required(),
      [WixChooseStationStepFormFieldsEnum.CampusStationId]: yupLanding
        .number()
        .required(
          t("landing.validation.required", {
            path: t("landing.formLabel.myOffice"),
          }),
        ),
      [WixChooseStationStepFormFieldsEnum.AcceptTerms]: yupLanding
        .boolean()
        .oneOf([true], t("landing.validation.acceptTermsRequired")),
      [WixChooseStationStepFormFieldsEnum.AcceptPrivacyPolicy]: yupLanding
        .boolean()
        .oneOf([true], t("landing.validation.acceptPrivacyPolicyRequired")),
    };
  }, [t]);

  return {
    yupChooseStationLandingValidationSchema,
  };
};
